"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userWorkspaceSettingsDataLoaderFactory = exports.insightDataLoaderFactory = exports.colorPaletteDataLoaderFactory = exports.clearInsightViewCaches = void 0;
var ColorPaletteDataLoader_1 = require("./ColorPaletteDataLoader");
Object.defineProperty(exports, "colorPaletteDataLoaderFactory", { enumerable: true, get: function () { return ColorPaletteDataLoader_1.colorPaletteDataLoaderFactory; } });
var InsightDataLoader_1 = require("./InsightDataLoader");
Object.defineProperty(exports, "insightDataLoaderFactory", { enumerable: true, get: function () { return InsightDataLoader_1.insightDataLoaderFactory; } });
var UserWorkspaceSettingsDataLoader_1 = require("./UserWorkspaceSettingsDataLoader");
Object.defineProperty(exports, "userWorkspaceSettingsDataLoaderFactory", { enumerable: true, get: function () { return UserWorkspaceSettingsDataLoader_1.userWorkspaceSettingsDataLoaderFactory; } });
/**
 * Clears all the caches used by the InsightView components.
 *
 * @public
 */
function clearInsightViewCaches() {
    var relevantFactories = [
        ColorPaletteDataLoader_1.colorPaletteDataLoaderFactory,
        InsightDataLoader_1.insightDataLoaderFactory,
        UserWorkspaceSettingsDataLoader_1.userWorkspaceSettingsDataLoaderFactory,
    ];
    relevantFactories.forEach(function (factory) { return factory.reset(); });
}
exports.clearInsightViewCaches = clearInsightViewCaches;
//# sourceMappingURL=index.js.map